import Immutable from 'immutable';
import {
  DOWNLOAD_EXPENSE_REPORT,
  FLAG_POSTING_EXPENSE_REPORT,
  POST_EXPENSE_REPORT,
  SHOW_ERROR_POSTING_EXPENSE_REPORT,
  CLEAR_ERROR_POSTING_EXPENSE_REPORT,
  GET_EXPENSE_REPORTS,
  FLAG_GETTING_EXPENSE_REPORTS,
  CLEAR_EXPENSE_REPORTS,
  SHOW_ERROR_GETTING_EXPENSE_REPORTS,
  CLEAR_ERROR_GETTING_EXPENSE_REPORTS,
  GET_EXPENSE_REPORT,
  FLAG_GETTING_EXPENSE_REPORT,
  CLEAR_EXPENSE_REPORT,
  CLEAR_ERROR_GETTING_EXPENSE_REPORT,
  SHOW_ERROR_GETTING_EXPENSE_REPORT,
} from '../../../actions/types';
import downloadCsv from '../../../utils/download-csv';

const INITIAL_STATE = Immutable.Map({
  form: Immutable.Map({
    error: null,
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    error: null,
    loading: false,
  }),
  all: Immutable.Map({
    content: Immutable.Map(),
    error: null,
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // downloading
    case DOWNLOAD_EXPENSE_REPORT:
      downloadCsv(action.payload, 'expense-report.csv');
      return state;

    // posting
    case FLAG_POSTING_EXPENSE_REPORT:
      return state.setIn(['form', 'loading'], action.payload);
    case POST_EXPENSE_REPORT:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case SHOW_ERROR_POSTING_EXPENSE_REPORT:
      return state.setIn(['form', 'error'], action.payload);
    case CLEAR_ERROR_POSTING_EXPENSE_REPORT:
      return state.deleteIn(['form', 'error']);

    // getting all
    case GET_EXPENSE_REPORTS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case FLAG_GETTING_EXPENSE_REPORTS:
      return state.setIn(['all', 'loading'], action.payload);
    case CLEAR_EXPENSE_REPORTS:
      return state.deleteIn(['all', 'content']);
    case SHOW_ERROR_GETTING_EXPENSE_REPORTS:
      return state.setIn(['all', 'error'], action.payload);
    case CLEAR_ERROR_GETTING_EXPENSE_REPORTS:
      return state.deleteIn(['all', 'error']);

    // getting one
    case GET_EXPENSE_REPORT:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case FLAG_GETTING_EXPENSE_REPORT:
      return state.setIn(['current', 'loading'], action.payload);
    case CLEAR_EXPENSE_REPORT:
      return state.deleteIn(['current', 'content']);
    case CLEAR_ERROR_GETTING_EXPENSE_REPORT:
      return state.deleteIn(['current', 'error']);
    case SHOW_ERROR_GETTING_EXPENSE_REPORT:
      return state.setIn(['current', 'error'], action.payload);

    default:
      return state;
  }
};
